import { render, staticRenderFns } from "./linkArticlesToCategory.vue?vue&type=template&id=31b6753c&"
import script from "./linkArticlesToCategory.vue?vue&type=script&lang=js&"
export * from "./linkArticlesToCategory.vue?vue&type=script&lang=js&"
import style0 from "./linkArticlesToCategory.vue?vue&type=style&index=0&id=31b6753c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports